import { useState } from "react";
import { toast } from "sonner";
import Reveal from "@/components/Reveal";
import { submitLead } from "@/lib/api";

const initial = { name: "", email: "", phone: "", city: "", state: "", investment_range: "", message: "" };

export default function Franchise() {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitLead({ type: "franchise", ...form });
      toast.success("Application received. Our team will review and follow up within a week.");
      setForm(initial);
    } catch {
      toast.error("Couldn't submit. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="franchise-page" className="bg-[#121212]">
      <section className="relative min-h-[55vh] flex items-end overflow-hidden">
        <img src="/brand-images/image23.jpg" alt="TacoSoul Truck" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/70 to-[#0a0a0a]/40" />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8 pb-16 md:pb-24 pt-32 w-full">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C99C3A] mb-4">Franchise Opportunities</p>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.98] text-[#F5ECD7]">
            Own the future of
            <br />
            <span className="font-serif-italic font-normal text-[#C99C3A]">Afro-Latina</span> street food.
          </h1>
        </div>
      </section>

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid md:grid-cols-3 gap-8 mb-16">
          {[
            { n: "01", t: "Proven Concept", b: "Charlotte-tested menu, deep brand IP, and a cultural story that resonates nationally." },
            { n: "02", t: "Operator Playbook", b: "Recipes, training, supply chain, and brand assets — built for scale." },
            { n: "03", t: "Founder Support", b: "Direct mentorship from our team. We grow with you, not past you." },
          ].map((v, i) => (
            <Reveal key={v.n} delay={i * 100} className="border-l-2 border-[#C99C3A] pl-6">
              <p className="font-display text-3xl text-[#C99C3A]">{v.n}</p>
              <h3 className="font-display text-2xl mt-2 tracking-tight text-[#F5ECD7]">{v.t}</h3>
              <p className="mt-3 text-[#F5ECD7]/65 leading-relaxed">{v.b}</p>
            </Reveal>
          ))}
        </div>

        <div className="max-w-4xl mx-auto px-0 md:px-8">
          <Reveal>
            <h2 className="font-display text-3xl md:text-5xl tracking-tighter text-[#F5ECD7]">
              Tell us about <span className="font-serif-italic font-normal text-[#C99C3A]">your market</span>.
            </h2>
          </Reveal>
          <Reveal delay={100} className="mt-10">
            <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2">
              <input data-testid="franchise-name" required placeholder="Full Name *" value={form.name} onChange={set("name")} className="input-line md:col-span-2" />
              <input data-testid="franchise-email" required type="email" placeholder="Email *" value={form.email} onChange={set("email")} className="input-line" />
              <input data-testid="franchise-phone" placeholder="Phone" value={form.phone} onChange={set("phone")} className="input-line" />
              <input data-testid="franchise-city" placeholder="Target City" value={form.city} onChange={set("city")} className="input-line" />
              <input data-testid="franchise-state" placeholder="State" value={form.state} onChange={set("state")} className="input-line" />
              <select data-testid="franchise-investment" value={form.investment_range} onChange={set("investment_range")} className="input-line md:col-span-2 bg-[#121212]">
                <option value="">Investment Range</option>
                <option>Under $100k</option>
                <option>$100k – $250k</option>
                <option>$250k – $500k</option>
                <option>$500k+</option>
              </select>
              <textarea data-testid="franchise-message" rows={4} placeholder="Tell us about your background and why you'd be a great partner..." value={form.message} onChange={set("message")} className="input-line md:col-span-2 resize-none" />
              <div className="md:col-span-2 mt-6">
                <button data-testid="franchise-submit" type="submit" disabled={loading} className="btn-gold">
                  {loading ? "Sending..." : "Submit Application"}
                </button>
              </div>
            </form>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
